document.addEventListener('click', function (e) {
    const menuRoot = document.querySelector('.mobile-header-sidebar__linklist');
    if (!menuRoot) return;
    const items = menuRoot.querySelectorAll('.mobile-item-has-children');

    items.forEach((item, index) => {
        const number = index + 1;

        // add unique class only once
        const baseClass = `sub-menu-${number}`;
        item.classList.add(baseClass);
        item.dataset.submenuClass = baseClass;
    });
});

document.addEventListener('click', function (e) {
  const summary = e.target.closest('.mobile-header-sidebar__linklist .mobile-sidebar-link-button');
  if (!summary) return;

  e.preventDefault();
  e.stopPropagation();

  const details = summary.closest('.mobile-group');
  const item = summary.closest('.mobile-item-has-children');
  const submenu = summary.nextElementSibling;
  const isExpanded = summary.getAttribute('aria-expanded') === 'true';

  if (!details || !submenu || !item) return;

  if (isExpanded) {
    summary.classList.remove('submenu-open');
    summary.setAttribute('aria-expanded', 'false');
    setTimeout(() => {
      details.setAttribute('aria-expanded', 'false');
    }, 0);
    item.classList.remove('mobile-item-has-children-open');
    submenu.classList.remove('mobile-submenu-open');
    submenu.style.setProperty('display', 'flex', 'important');
    details.removeAttribute('open');
  } else {
    summary.classList.add('submenu-open');
    summary.setAttribute('aria-expanded', 'true');
    setTimeout(() => {
      details.setAttribute('aria-expanded', 'true');
    }, 0);
    item.classList.add('mobile-item-has-children-open');
    submenu.classList.add('mobile-submenu-open');
    submenu.style.setProperty('display', 'flex', 'important'); // or block
    details.setAttribute('open', '');
    
  }
});


document.addEventListener('click', function (e) {
  const backBtn = e.target.closest('.sidebar-back-button[data-action="close-sub-panel"]');
  if (!backBtn) return;
  //alert("back menu:- mobile-submenu-open remove class");

  e.preventDefault();

  const submenu = backBtn.closest('.mobile-sub-menu');
  const details = backBtn.closest('.mobile-group');
  const item = backBtn.closest('.mobile-item-has-children');
  const summary = details.querySelector('.mobile-sidebar-link-button');

  if (summary) {
    summary.classList.remove('submenu-open');
    setTimeout(() => {
      details.setAttribute('aria-expanded', 'false');
      //alert(details ? 'details found 1' : 'details not found 1');
      //alert(details ? details.className : 'details not found 1');
      //alert(details ? details.outerHTML : 'details not found 1');
    }, 0);
    summary.setAttribute('aria-expanded', 'false');
    //alert(details ? 'details found 2' : 'details not found 2');
    //alert(details ? details.className : 'details not found 2');
    //alert(details ? details.outerHTML : 'details not found 2');
  }

  if (item) {
    item.classList.remove('mobile-item-has-children-open');
    //alert(item ? item.outerHTML : 'item not found 1');
    //alert(item.outerHTML);
  } else {
    //alert('item not found 1');
  }

  if (submenu) {
    submenu.classList.remove('mobile-submenu-open');
    submenu.style.display = 'none';
    submenu.style.setProperty('display', 'none', 'important');
  }
  if (details) details.removeAttribute('open');
});

